import PropTypes from "prop-types"
import { AppBar } from "@mui/material"
import { Link } from "react-router-dom"
import Logo from "components/logo"
import ServerNotifications from "modules/server-notifications"
import HelpMenu from "modules/help-menu"
import ThemeModeToggle from "components/theme-mode-toggle"

export default function HomeHeader({ account, Icon = null, title = null, children, className, modelId }) {
  return <AppBar position="sticky" className={className}>
    <div className="header-app-bar">
      <div className="left">
        <Link className="logo" to={`/${account}/home`}>
          <Logo />
        </Link>
        {Icon && <Icon />}
        {title && <span className="title">{title}</span>}
        {children}
      </div>
      <div className="right">
        <ServerNotifications homeVersion />
        <HelpMenu iconButton modelId={modelId} />
        <ThemeModeToggle inline />
      </div>
    </div>
  </AppBar>
}

HomeHeader.propTypes = {
  account: PropTypes.string.isRequired,
  Icon: PropTypes.object,
  title: PropTypes.string,
  help: PropTypes.element,
  className: PropTypes.string,
  modelId: PropTypes.string,
}
